import { render, staticRenderFns } from "./MoviesList.vue?vue&type=template&id=8f100690&scoped=true&"
import script from "./MoviesList.vue?vue&type=script&lang=js&"
export * from "./MoviesList.vue?vue&type=script&lang=js&"
import style0 from "./MoviesList.vue?vue&type=style&index=0&id=8f100690&lang=scss&scoped=true&"
import style1 from "./MoviesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f100690",
  null
  
)

export default component.exports